<ion-grid>
  <ion-row *ngIf="me?.socialCauses && me?.socialCauses.length > 0">
    <ion-col>
      <ion-card>
        <ion-card-content>
          <ion-label>{{'socialCauses' | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="me?.socialCauses && me?.socialCauses.length > 0">
    <ng-container *ngIf="me?.socialCauses && me?.socialCauses.length > 0">
      <ion-col *ngFor="let cause of me?.socialCauses">
        <ion-card>
          <ion-card-content>
            <ion-label>{{getSocialCauseDisplayText(cause)}}</ion-label>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ng-container>
  </ion-row>
  <ion-row>
    <ion-col *ngIf="me?.city != null && me?.city.trim() != ''">
      <ion-card ion-card>
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/icon-location-small.svg"></ion-icon>
          <ion-label>{{me?.city}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="this.me?.gender2 != null && this.me?.gender2 == 'other'">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/distance-units-white.svg"></ion-icon>
          <ion-label>{{this.me?.genderdescription}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.lookingForHelp && me?.diet != 'vegan'">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/raise-hand-white.svg"></ion-icon>
          <ion-label>{{'lookingForHelp' | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.willingToHelp && me?.diet == 'vegan'">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/helping-white.svg"></ion-icon>
          <ion-label>{{'willingToHelp' | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.lookingFor != null && me.lookingFor.length == 1 && me.lookingFor.includes('friendship')">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/amigos-branco.svg"></ion-icon>
          <ion-label>{{'friendshipOnly' | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.activism != null">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/ativism-white.svg"></ion-icon>
          <ion-label>{{me?.activism | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.work != null && me?.work.trim() != ''">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/work-white.svg"></ion-icon>
          <ion-label>{{me?.work | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.education != null">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/education-white.svg"></ion-icon>
          <ion-label>{{me?.education | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.height != null">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/height-white.svg"></ion-icon>
          <ion-label>{{setHeight()}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.exercise != null">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/exercise-white.svg"></ion-icon>
          <ion-label>{{me?.exercise | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.lookingFor != null && me?.lookingFor.length > 0">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/search-white.svg"></ion-icon>
          <ion-label>{{lookingForOptions()}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.children != null">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/kids-white.svg"></ion-icon>
          <ion-label>{{me?.children | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.astrologySign != null && me?.astrologySign.trim() != ''">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/sign-white.svg"></ion-icon>
          <ion-label>{{me?.astrologySign | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.religion != null && me?.religion.trim() != ''">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/religion-white.svg"></ion-icon>
          <ion-label>{{me?.religion | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.politics != null && me?.politics.trim() != ''">
      <ion-card >
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/politics-white.svg"></ion-icon>
          <ion-label>{{me?.politics | translate}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col *ngIf="me?.pets != null && me?.pets.trim() != ''">
      <ion-card>
        <ion-card-content>
          <ion-icon src="assets/imgs/icons/animals-white.svg"></ion-icon>
          <ion-label>{{me?.pets}}</ion-label>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
